\:host
    width: 100%
